/*
  <kashira-journal-tabs> — journal category tab rail (spec 06 a).

  The tabs are real links (crawlable); this only handles the mobile
  affordances the spec asks for:
   - pins the active tab into view inside the horizontal scroll rail
   - toggles edge-fade classes so the fade only shows where content
     actually continues past the edge
*/
if (!customElements.get('kashira-journal-tabs')) {
  customElements.define(
    'kashira-journal-tabs',
    class KashiraJournalTabs extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('.kashira-blog-tags');
        if (!this.rail) return;

        this.updateFades = this.updateFades.bind(this);
        this.rail.addEventListener('scroll', this.updateFades, { passive: true });
        window.addEventListener('resize', this.updateFades, { passive: true });

        this.pinActive();
        this.updateFades();
      }

      disconnectedCallback() {
        if (this.rail) this.rail.removeEventListener('scroll', this.updateFades);
        window.removeEventListener('resize', this.updateFades);
      }

      pinActive() {
        const active = this.rail.querySelector('.kashira-blog-tags__link--active');
        if (!active) return;
        const offset = active.offsetLeft - (this.rail.clientWidth - active.offsetWidth) / 2;
        if (offset <= 0) return;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.rail.scrollTo({ left: offset, behavior: reduced ? 'auto' : 'smooth' });
      }

      updateFades() {
        const max = this.rail.scrollWidth - this.rail.clientWidth;
        this.classList.toggle('kashira-blog-tags-wrap--fade-start', this.rail.scrollLeft > 4);
        this.classList.toggle('kashira-blog-tags-wrap--fade-end', this.rail.scrollLeft < max - 4);
      }
    }
  );
}
